module.exports = __webpack_public_path__ + "static/media/screenshot-job-post.abc5da35.png";